/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const TabsHeader = ({
  tabList,
  activeTab,
  setActiveTab,
}: {
  tabList: any;
  activeTab: string;
  setActiveTab: (prop: string) => void;
}) => {
  return (
    <div className="flex gap-2 ">
      {tabList?.map((tab: any) => {
        return (
          <Button
            key={tab.id}
            className={cn(
              "rounded-none",
              activeTab === tab.id &&
                "border-2 border-primary rounded-none border-t-0 border-l-0 border-r-0"
            )}
            onClick={() => setActiveTab(tab.id)}
            variant={"ghost"}
          >
            {tab.label}
          </Button>
        );
      })}
    </div>
  );
};
